// extracted by mini-css-extract-plugin
export default {"message-md":"Popover_message-md__PfnYJ","message-lg":"Popover_message-lg__Bys3S"};